import { useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function ArticleTabsHelpers() {
    const { unchangedArticle } = useAppSelector((state) => state.artical);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formData, setFormData] = useState({
        articleNumber: "",
        articleGroup: "",
        name: "",
        brand: "",
        type: "",
        data: "",
        supplierArticleNumber: "",
        unit: "",
        grossPrice: 0,
        discount: 0,
        netPrice: 0,
        sellingPrice: 0,
        priceDate: new Date(),
        stock1: "",
        location1: "",
        stock2: "",
        location2: "",
        note: "",
        supplierId: 0,
        obsolete: false
    });
    const [errors, setErrors] = useState({
        articleNumber: "",
        name: "",
    });
    useEffect(() => {
        if (!errors.articleNumber && !errors.name) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
    const handleToggelButtonChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleCalendarChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    useEffect(() => {
        checkBoldFieldsArticle();
        checkunchangedFieldsArticle();
    }, [formData, unchangedArticle]);
    const validateForm = () => {
        const newErrors = {
            articleNumber: "",
            name: "",
        };
        if (!formData.articleNumber) {
            newErrors.articleNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (!formData.name) {
            newErrors.name = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Unsaved Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isNotesTabUnsaved, setNotesTabUnsaved] = useState(false);
    const { id } = useParams();
    const checkunchangedFieldsArticle = () => {
        if (unchangedArticle && formData && id) {
            let isInfoTabUnsaved = false;
            let isNotitiesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedArticle.articleNumber != formData.articleNumber ||
                unchangedArticle.articleGroup != formData.articleGroup ||
                unchangedArticle.brand != formData.brand ||
                unchangedArticle.type != formData.type ||
                unchangedArticle.name != formData.name ||
                unchangedArticle.obsolete != formData.obsolete ||
                unchangedArticle.data != formData.data ||
                unchangedArticle.supplierId != formData.supplierId ||
                unchangedArticle.supplierArticleNumber != formData.supplierArticleNumber ||
                unchangedArticle.location1 != formData.location1 ||
                unchangedArticle.location2 != formData.location2 ||
                unchangedArticle.stock1 != formData.stock1 ||
                unchangedArticle.stock2 != formData.stock2 ||
                unchangedArticle.unit != formData.unit ||
                unchangedArticle.grossPrice != formData.grossPrice ||
                unchangedArticle.discount != formData.discount ||
                Math.round(Number(unchangedArticle.netPrice || 0) * 10000) !== Math.round(Number(formData.netPrice || 0) * 10000) ||
                unchangedArticle.sellingPrice != formData.sellingPrice ||
                unchangedArticle.priceDate != formData.priceDate) {
                isInfoTabUnsaved = true;
            }
            // Check for unsaved changes in the Notes
            if (unchangedArticle.note != formData.note) {
                isNotitiesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
            setNotesTabUnsaved(isNotitiesTabUnsaved);
        }
    };
    const checkBoldFieldsArticle = () => {
        if (formData.articleNumber || formData.articleGroup || formData.brand || formData.type || formData.name || formData.obsolete == true || formData.data || formData.supplierId
            || formData.supplierArticleNumber || formData.stock1 || formData.stock2 || formData.location1 || formData.location2 || formData.unit
            || formData.grossPrice || formData.discount || formData.netPrice || formData.sellingPrice || formData.priceDate) {
            setIsInfoTabBold(true);
        }
        if (formData.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        handleFieldChange,
        handleToggelButtonChange,
        handleCalendarChange,
        validateForm,
        formData,
        setFormData,
        errors,
        isInfoTabUnsaved,
        isNotesTabUnsaved,
        infoTabErrorBorderColor,
        isInfoTabBold,
        isNotesTabBold
    };
}
